import { useEffect, useState } from "react";
import fetchWrapper from "../utils/fetch";
import { Spinner } from "@nextui-org/react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/auth-context";
import { toast } from "react-toastify";

export default function BlogSection({ cat, title, subtitle }) {
  const [templates, setTemplates] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchWrapper
      .post("/get/problems/category", {
        category: cat,
      })
      .then((data) => {
        setTemplates(data.problems);
      })
      .catch((err) => {
        toast.error("در دریافت قالب‌های تصمیم گیری آماده مشکلی پیش آمده");
      });
  }, [setIsLoading, setTemplates, cat]);

  const handleProblemClick = (problem) => {
    navigate(`/problem/create?template_id=${problem.problem_uid}`);
  };

  return (
    <div className="py-24 sm:py-32 z-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto text-right">
          <h2 className="text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
            {title}:
          </h2>
          {/* <p className="mt-2 text-lg leading-8 text-gray-600">{subtitle}</p> */}
        </div>
        <div className="">
          {isLoading ? (
            <Spinner color="secondary" />
          ) : (
            // <div className="mx-auto mt-12 grid max-w-2xl auto-rows-fr grid-cols-2 sm:grid-cols-3 gap-8 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-6">
            <div className="mx-auto mt-12 grid max-w-2xl auto-rows-fr grid-cols-1 gap-8 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
              {templates.map((problem) => (
                <div className="size-full flex flex-row py-3 px-2 items-center gap-4">
                  <div className="rounded-full border-[8px] border-gray-700 size-32 overflow-hidden text-center flex justify-center items-center">
                    <div
                      onClick={() => handleProblemClick(problem)}
                      className="size-full cursor-pointer"
                    >
                      <img
                        className="object-fill size-full"
                        src={problem.problem_photo}
                        alt={problem.problem_name}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div
                      onClick={() => handleProblemClick(problem)}
                      className="cursor-pointer"
                    >
                      <p className="text-lg font-bold">
                        {problem.problem_name}
                      </p>
                    </div>
                    <div
                      onClick={() => handleProblemClick(problem)}
                      className="text-sm font-semibold leading-6 text-blue-700 underline underline-offset-4 cursor-pointer"
                    >
                      استفاده کنید <span aria-hidden="true">→</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
